import i18n from '~/i18n/locale';
import locales from './locales';

const DEFAULT_RULES = {
  symbol: true
};

export default class MoneyFormatter {
  constructor(money) {
    this.money = money;
    this.fractional = money.fractional;
    this.currency = money.currency;
    this.rules = {};
  }

  format(rules = {}) {
    this.rules = { ...DEFAULT_RULES, ...rules };

    let [wholePart, decimalPart] = this.extractParts();

    wholePart = this.formatWholePart(wholePart);

    return [wholePart, decimalPart].join(this.decimalMark());
  }

  extractParts() {
    const fractional = Math.abs(this.fractional);
    let floatNumber = fractional / 100.00;

    return floatNumber.toFixed(2).split('.');
  }

  formatWholePart(wholePart) {
    wholePart = this.addThousandsSeparator(wholePart);
    wholePart = this.addNegativeSign(wholePart);
    wholePart = this.addSymbol(wholePart);

    return wholePart;
  }

  addNegativeSign(wholePart) {
    return this.money.negative() ? `-${wholePart}` : wholePart;
  }

  addSymbol(wholePart) {
    if (this.rules.symbol) {
      return `${this.currency.symbol} ${wholePart}`;
    } else {
      return wholePart;
    }
  }

  addThousandsSeparator(part) {
    return part.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator());
  }

  thousandsSeparator() {
    let thousandsSeparator;

    if (i18n.locale) {
      thousandsSeparator = locales[i18n.locale].thousandsSeparator;
    }

    return thousandsSeparator ? thousandsSeparator : this.currency.thousandsSeparator;
  }

  decimalMark() {
    let decimalMark;

    if (i18n.locale) {
      decimalMark = locales[i18n.locale].decimalMark;
    }

    return decimalMark ? decimalMark : this.currency.decimalMark;
  }
}
